import { memo, useCallback } from 'react'

import { Typography, Divider } from '@mui/material'
import { AvcInstance } from '@nativewaves/nw-cloud-sdk/content'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useAvcInstanceDeleteMutation } from 'hooks/mutations/content'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<AvcInstance>) => {
  const { t } = useTranslation(['common', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: deleteAvcInstance } = useAvcInstanceDeleteMutation()

  const handleDeleteAvcInstance = useCallback(() => {
    onClose()

    deleteAvcInstance(
      { instanceId: row.original.id },
      {
        onSuccess: () =>
          enqueueSnackbar(t('domain:ContentProcessing.Instance.nameDelete', { name: row.original.name }), {
            variant: 'success',
          }),
      },
    )
  }, [deleteAvcInstance, enqueueSnackbar, onClose, row.original.id, row.original.name, t])

  return (
    <>
      <Typography sx={{ mx: 2, my: 1, color: 'action.disabled' }} component="li">
        {t('domain:ContentProcessing.Instance.noFurtherActions')}
      </Typography>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemDelete onConfirm={handleDeleteAvcInstance} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
